/**
 * Big Win Class
 *
 *
 */

(function () {
  class BigWin extends PIXI.Container {
    constructor() {
      super();

      // Big win levels
      this.NICE_WIN = 1;
      this.BIG_WIN = 2;
      this.SUPER_WIN = 3;
      this.MEGA_WIN = 4;
      this.EPIC_WIN = 5;
      this.AWESOME_WIN = 6;

      this._niceWinThreshold = 10;
      this._bigWinThreshold = 20;
      this._superWinThreshold = 50;
      this._megaWinThreshold = 100;
      this._epicWinThreshold = 200;
      this._awesomeWinThreshold = 500;

      this._totalDuration = 7600; // the big win tune is 7.6 seconds long
      this._winType = this.NICE_WIN;

      this.isActive = false;
      this.skipWin = false;
      this.allowSkipWin = false;
      this.currentLevel = 0;
      this.currentTitle = null;

      this.winAmount = 0;
      this.callback = undefined;
      this.countUpPromise = null;
      this.bigWinPromise = null;
    }

    getWinType(amount, stake) {
      if (amount >= stake * this._awesomeWinThreshold) {
        return this.AWESOME_WIN;
      } else if (amount >= stake * this._epicWinThreshold) {
        return this.EPIC_WIN;
      } else if (amount >= stake * this._megaWinThreshold) {
        return this.MEGA_WIN;
      } else if (amount >= stake * this._superWinThreshold) {
        return this.SUPER_WIN;
      } else if (amount >= stake * this._bigWinThreshold) {
        return this.BIG_WIN;
      } else {
        return this.NICE_WIN;
      }
    }

    getNiceWinThreshold() {
      return this._niceWinThreshold;
    }

    getBigWinThreshold() {
      return this._bigWinThreshold;
    }

    getSuperWinThreshold() {
      return this._superWinThreshold;
    }

    getMegaWinThreshold() {
      return this._megaWinThreshold;
    }

    getEpicWinThreshold() {
      return this._epicWinThreshold;
    }

    getAwesomeWinThreshold() {
      return this._awesomeWinThreshold;
    }

    willTriggerBigWin(amount, stake) {
      const threshold = stake * this._niceWinThreshold;
      return amount >= threshold;
    }

    init() {
      this._dimScreen = resourceManager.get('bigWinDimObject');
      this._dimScreen.show(false);

      this._bigWinContainer = resourceManager.getContainer('bigWinContainer');
      this._bigWinContainer.visible = false;

      // Value Text Backing
      this._winAwardTextBacking = resourceManager.get('bigWin:BigWin:awardTextBacking');
      this._winAwardTextBacking.visible = false;

      // NOTE: This uses a meter - you can't override the font size of the meter
      this._winAwardText = resourceManager.get('bigWin:BigWin:awardTextBacking:awardText');
      this._winAwardText.visible = false;

      this._awardTextFinalPos = resourceManager.get('bigWin:BigWin:awardTextFinalPos');
      this._awardTextStartPos = resourceManager.get('bigWin:BigWin:awardTextStartPos');

      this._niceWinTextContainer = resourceManager.get('bigWin:BigWin:niceWinTextContainer');
      this._niceWinTextContainer.visible = false;

      this._bigWinTextContainer = resourceManager.get('bigWin:BigWin:bigWinTextContainer');
      this._bigWinTextContainer.visible = false;

      this._superWinTextContainer = resourceManager.get('bigWin:BigWin:superWinTextContainer');
      this._superWinTextContainer.visible = false;

      this._megaWinTextContainer = resourceManager.get('bigWin:BigWin:megaWinTextContainer');
      this._megaWinTextContainer.visible = false;

      this._epicWinTextContainer = resourceManager.get('bigWin:BigWin:epicWinTextContainer');
      this._epicWinTextContainer.visible = false;

      this._awesomeWinTextContainer = resourceManager.get('bigWin:BigWin:awesomeWinTextContainer');
      this._awesomeWinTextContainer.visible = false;

      this.burst1 = resourceManager.get('bigWin:BigWin:BurstContainer:Burst1');
      this.burst1.visible = false;
      this.burst2 = resourceManager.get('bigWin:BigWin:BurstContainer:Burst2');
      this.burst2.visible = false;

      this._emitter1 = particleManager.createEmitter(
        'bigwin_emitter1',
        'bigWin:BigWin:particlesContainer',
        0,
        0,
        false
      );
      this._emitter1.particleEmitter.emit = false;
      this._emitter1.visible = false;

      this._emitter2 = particleManager.createEmitter(
        'bigwin_emitter2',
        'bigWin:BigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._emitter2.particleEmitter.emit = false;
      this._emitter2.visible = false;

      this._emitter3 = particleManager.createEmitter(
        'bigwin_emitter3',
        'bigWin:BigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._emitter3.particleEmitter.emit = false;
      this._emitter3.visible = false;

      this._emitter4 = particleManager.createEmitter(
        'bigwin_emitter4',
        'bigWin:BigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._emitter4.particleEmitter.emit = false;
      this._emitter4.visible = false;

      this._emitter5 = particleManager.createEmitter(
        'bigwin_emitter5',
        'bigWin:BigWin:particlesContainer',
        0,
        -100,
        false
      );
      this._emitter5.particleEmitter.emit = false;
      this._emitter5.visible = false;

      this._skipBigWinBox = resourceManager.get('bigWin:BigWin:skipBigWinBox');
      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.visible = true;
      this._skipBigWinBox.interactive = false;
      this._skipBigWinBox.mousedown = this._skipBigWinBox.touchstart = () => {
        this.skip();
      };

      // this._cappedWinPopup = resourceManager.get('maxWinPopup');
      // this._cappedWinPopup.visible = false;
      // this._cappedWinPopupButton = resourceManager.get('maxWinPopup:continueButton');
      // this._cappedWinPopupButton.interactive = false;

      this.presentLevelData = [
        {
          level: this.NICE_WIN,
          previousTitle: null,
          nextTitle: this._niceWinTextContainer,
          threshold: null,
          nextThreshold: null,
          emitterToStop: null,
          emitterToStart: null,
        },
        {
          level: this.BIG_WIN,
          previousTitle: this._niceWinTextContainer,
          nextTitle: this._bigWinTextContainer,
          threshold: this.getBigWinThreshold(),
          nextThreshold: this.getSuperWinThreshold(),
          emitterToStop: null,
          emitterToStart: this._emitter1,
        },
        {
          level: this.SUPER_WIN,
          previousTitle: this._bigWinTextContainer,
          nextTitle: this._superWinTextContainer,
          threshold: this.getSuperWinThreshold(),
          nextThreshold: this.getMegaWinThreshold(),
          emitterToStop: this._emitter1,
          emitterToStart: this._emitter2,
        },
        {
          level: this.MEGA_WIN,
          previousTitle: this._superWinTextContainer,
          nextTitle: this._megaWinTextContainer,
          threshold: this.getMegaWinThreshold(),
          nextThreshold: this.getEpicWinThreshold(),
          emitterToStop: this._emitter2,
          emitterToStart: this._emitter3,
        },
        {
          level: this.EPIC_WIN,
          previousTitle: this._megaWinTextContainer,
          nextTitle: this._epicWinTextContainer,
          threshold: this.getEpicWinThreshold(),
          nextThreshold: this.getAwesomeWinThreshold(),
          emitterToStop: this._emitter3,
          emitterToStart: this._emitter4,
        },
        {
          level: this.AWESOME_WIN,
          previousTitle: this._epicWinTextContainer,
          nextTitle: this._awesomeWinTextContainer,
          threshold: this.getAwesomeWinThreshold(),
          nextThreshold: null,
          emitterToStop: this._emitter4,
          emitterToStart: this._emitter5,
        },
      ];
    }

    isBigWinActive() {
      return this.isActive;
    }

    // TODO !!!!!!!!!!!
    showCappedWinPopup(callback) {
      // this._cappedWinPopup.visible = true;
      // this._cappedWinPopup.alpha = 0;
      // this.isActive = true;
      // const self = this;
      // timerManager.addTimer(
      //   500,
      //   function (progress) {
      //     self._dimScreen.show(true);
      //     self._dimScreen.alpha = progress * 0.6;
      //     self._cappedWinPopup.alpha = progress;
      //   },
      //   function () {
      //     self._dimScreen.show(true);
      //     self._dimScreen.alpha = 0.6;
      //     self._cappedWinPopup.alpha = 1;
      //     self._cappedWinPopupButton.interactive = true;
      //     self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = function () {
      //       self._cappedWinPopup.visible = false;
      //       self._dimScreen.show(false);
      //       self._cappedWinPopupButton.interactive = false;
      //       self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = function () {};
      //       callback();
      //     };
      //   }
      // );
    }

    start(winAmount, capped, cbOnPresentLevel, cbOnCountUpFinished, cbWhenFinished, whereFrom = '') {
      // capped isnt needed in this game and the pop up shown much earlier
      this.whereFrom = whereFrom;
      this.doBigWin(winAmount, cbOnPresentLevel, cbOnCountUpFinished, cbWhenFinished);
    }

    getAmountToCountUp(nextThreshold, threshold) {
      let amountToCountUp = 0;

      if (nextThreshold === null && threshold === null) {
        // return 0
      } else if (nextThreshold === null) {
        // got to the highest stage
        amountToCountUp = this.winAmount - this._bigWinCurrentStake * threshold;
      } else {
        amountToCountUp =
          Math.min(this._bigWinCurrentStake * nextThreshold, this.winAmount) - this._bigWinCurrentStake * threshold;
      }
      return amountToCountUp;
    }

    getBigWinPromise() {
      return this.bigWinPromise;
    }

    async doBigWin(winAmount, cbOnPresentLevel, cbOnCountUpFinished, cbWhenFinished) {
      let doBigWinResolver = null;
      this.bigWinPromise = new Promise((resolve) => {
        doBigWinResolver = resolve;
      });

      this.winAmount = winAmount;
      this.isActive = true;
      this.skipWin = false;
      this.allowSkipWin = false;

      // lets dim the screen
      this._dimScreen.show(true);
      this._dimScreen.alpha = 0;
      gsap.to(this._dimScreen, {
        duration: 0.3,
        alpha: 0.6,
      });

      this._bigWinCurrentStake = gameController.globalHelperGetBaseStake();

      this._winType = this.getWinType(this.winAmount, this._bigWinCurrentStake);
      const duration = this._totalDuration / this._winType;
      this.visible = true;

      await this.intro();

      for (let i = 0; i < this.presentLevelData.length; i++) {
        const presentLevelData = this.presentLevelData[i];
        const { threshold, level, nextTitle } = presentLevelData;
        if (this.winAmount >= this._bigWinCurrentStake * threshold) {
          this.currentLevel = level;
          this.currentTitle = nextTitle;
          if (cbOnPresentLevel) {
            cbOnPresentLevel();
          }
          await this.presentLevel(presentLevelData, duration);
        }
      }

      musicManager.playBigWinEnd();

      if (cbOnCountUpFinished) {
        cbOnCountUpFinished();
      }

      // disable the skip
      this._skipBigWinBox.interactive = false;
      this.allowSkipWin = false;

      await this.showFinalResult();

      await this.outro();

      let level = musicManager.SPINLEVEL;
      if (this.whereFrom === 'gamble') {
        level = musicManager.IDLELEVEL;
      } else if (this.whereFrom === 'freespinsInter') {
        level = musicManager.FREESPINS_LEVEL1;
      } else if (this.whereFrom === 'freespinsEnd') {
        level = musicManager.FREESPINS_LEVEL1;
      } else {
        const bgTrail = resourceManager.get('bgTrail:BGTrailContainer');
        if (bgTrail.isFull() === true) {
          level = musicManager.SINGLEWINLEVEL;
        }
      }
      musicManager.stopBigWinEnd(level);

      this.isActive = false;
      this.visible = false;

      if (cbWhenFinished) {
        cbWhenFinished();
      }

      doBigWinResolver();
      this.bigWinPromise = null;
    }

    canSkip() {
      return this.isActive && !this.skipWin && this.allowSkipWin;
    }

    degreesToRadians(degrees) {
      return degrees * (Math.PI / 180);
    }

    // not using the one from game, because we have listenForSkipWin
    // and i cant for the life of me work out how to make it generic for now
    async tweenFromToAsync(targets, fromVars, toVars, tweenInfo = null) {
      let resolver = null;
      const tweenPromise = new Promise((resolve) => {
        resolver = resolve;
      });

      const origOnComplete = toVars.onComplete;
      toVars.paused = true;
      if (toVars.listenForSkipWin === true) {
        const self = this;
        toVars.onUpdate = function () {
          if (self.skipWin) {
            this.progress(1);
          }
        };
      }
      toVars.listenForSkipWin = null;
      delete toVars.listenForSkipWin;
      toVars.onComplete = () => {
        if (origOnComplete) {
          origOnComplete();
        }
        resolver();
      };

      const tween = gsap.fromTo(targets, fromVars, toVars);
      tween.time(0).restart(true);

      if (tweenInfo) {
        tweenInfo.tween = tween;
        tweenInfo.resolver = resolver;
        tweenInfo.promise = tweenPromise;
      }

      return tweenPromise;
    }

    async scaleInBursts() {
      this.burst1.visible = true;
      this.burst2.visible = true;

      await Promise.all([
        this.tweenFromToAsync(
          this.burst1.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1.5,
            y: 1.5,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this.burst2.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1,
            y: 1,
            duration: 0.5,
          }
        ),
      ]);
    }

    async fadeInBursts() {
      await Promise.all([
        this.tweenFromToAsync(
          this.burst1,
          {
            alpha: 0,
          },
          {
            alpha: 0.6,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this.burst2,
          {
            alpha: 0,
          },
          {
            alpha: 0.5,
            duration: 0.5,
          }
        ),
      ]);
    }

    async scaleInTitle(title, listenForSkipWin = false) {
      title.alpha = 1;
      title.visible = true;
      await this.tweenFromToAsync(
        title.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          listenForSkipWin: listenForSkipWin,
          duration: 0.5,
        }
      );
    }

    async moveInWinAwardTextBacking() {
      this._winAwardTextBacking.scale.x = 1;
      this._winAwardTextBacking.scale.y = 1;
      this._winAwardTextBacking.visible = true;

      await Promise.all([
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            x: this._awardTextStartPos.position.getX(),
            y: this._awardTextStartPos.position.getY(),
          },
          {
            x: this._awardTextFinalPos.position.getX(),
            y: this._awardTextFinalPos.position.getY(),
            duration: 0.333,
          }
        ),
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.2,
          }
        ),
      ]);
    }

    async moveOutWinAwardTextBacking() {
      await Promise.all([
        this.tweenFromToAsync(
          this._winAwardTextBacking,
          {
            x: this._awardTextFinalPos.position.getX(),
            y: this._awardTextFinalPos.position.getY(),
          },
          {
            x: this._awardTextStartPos.position.getX(),
            y: this._awardTextStartPos.position.getY(),
            duration: 0.5,
          }
        ),
      ]);

      this._winAwardTextBacking.visible = false;
      this._winAwardText.set(0);
      this._winAwardText.visible = false;
    }

    startRotatingBursts() {
      // start the bursts rotating
      this.burst1.rotation = 0;
      this.burst2.rotation = 0;
      this.rotateBurst1Tween = gsap.to(this.burst1, {
        duration: 12,
        rotation: this.degreesToRadians(359),
        repeat: -1,
        ease: 'none',
      });
      this.rotateBurst2Tween = gsap.to(this.burst2, {
        duration: 12,
        rotation: this.degreesToRadians(-359),
        repeat: -1,
        ease: 'none',
      });
    }

    stopRotatingBursts() {
      if (this.rotateBurst1Tween) {
        this.rotateBurst1Tween.kill();
        this.rotateBurst1Tween = null;
      }
      if (this.rotateBurst2Tween) {
        this.rotateBurst2Tween.kill();
        this.rotateBurst2Tween = null;
      }
    }

    // Big win intro - this can't be skipped
    async intro() {
      musicManager.playBigWin();

      const firstLevelData = this.presentLevelData[0];

      // lets kick off the 1st emitter
      if (firstLevelData.emitterToStart) {
        firstLevelData.emitterToStart.particleEmitter.emit = true;
        firstLevelData.emitterToStart.visible = true;
      }

      // set the count up to show big win starting value and hide
      // dont use the nice win threshold, as nice win comes in straight away, use the big win, as this is when
      // the title switches and exits the presentLevel
      let amountToCountUp = Math.min(this._bigWinCurrentStake * this.getBigWinThreshold(), this.winAmount);

      this._winAwardText.set(0);
      this._winAwardText.visible = true;
      const duration = this._totalDuration / this._winType;
      this.countUpPromise = this.countUp(amountToCountUp, duration);

      this.startRotatingBursts();

      // make ourselves visible
      this._bigWinContainer.visible = true;

      this.previousTitle = null;
      this.currentTitle = firstLevelData.nextTitle;

      // lets start bringing stuff in
      const scaleInBurstsPromise = this.scaleInBursts();
      const fadeInBurstsPromise = this.fadeInBursts();
      const scaleInTitlePromise = this.scaleInTitle(this.currentTitle);
      const moveInWinAwardTextBackingPromise = this.moveInWinAwardTextBacking();

      // wait for all the intro tweens to finish
      await Promise.all([
        scaleInBurstsPromise,
        fadeInBurstsPromise,
        scaleInTitlePromise,
        moveInWinAwardTextBackingPromise,
      ]);
    }

    async countUp(amountToCountUp, duration) {
      this.countUpResolver = null;
      const countUpPromise = new Promise((resolve) => {
        this.countUpResolver = resolve;
      });

      this._winAwardText.countUp(amountToCountUp, duration, () => {
        this.countUpResolver();
        this.countUpResolver = null;
      });

      await countUpPromise;
    }

    pulseTitle(title) {
      this.pulseTitleTween = gsap.fromTo(
        title.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.1,
          y: 1.1,
          duration: 0.15,
          repeat: -1,
          yoyo: true,
        }
      );
    }

    stopPulsingTitle() {
      this.pulseTitleTween.kill();
    }

    pulseWinAwardText() {
      this.pulseWinAwardTextTween = gsap.fromTo(
        this._winAwardText.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.1,
          y: 1.1,
          duration: 0.15,
          repeat: -1,
          yoyo: true,
        }
      );
    }

    stopPulsingWinAwardText() {
      this.pulseWinAwardTextTween.kill();
      this._winAwardText.scale.x = 1;
      this._winAwardText.scale.y = 1;
    }

    async scaleOutAndFadeOffTitle(title, listenForSkipWin = false) {
      await Promise.all([
        this.tweenFromToAsync(
          title.scale,
          {
            x: title.scale.x,
            y: title.scale.y,
          },
          {
            x: 3,
            y: 3,
            listenForSkipWin: listenForSkipWin,
            duration: 0.75,
          }
        ),
        this.tweenFromToAsync(
          title,
          {
            alpha: 1,
          },
          {
            alpha: 0,
            listenForSkipWin: listenForSkipWin,
            duration: 0.5,
          }
        ),
      ]);
    }

    async presentLevel(levelData, duration) {
      const { previousTitle, nextTitle, threshold, nextThreshold, emitterToStop, emitterToStart } = levelData;

      if (previousTitle) {
        this.stopPulsingTitle();
        this.scaleOutAndFadeOffTitle(previousTitle, true);
      }

      if (emitterToStop) {
        emitterToStop.particleEmitter.emit = false;
      }
      if (emitterToStart) {
        emitterToStart.particleEmitter.emit = true;
        emitterToStart.visible = true;
      }

      this._winAwardText.visible = true;
      if (!this.countUpSound) {
        this.countUpSound = soundManager.play('winCountUp');
      }

      if (!this.skipWin) {
        if (this.countUpPromise === null) {
          const amountToCountUp = this.getAmountToCountUp(nextThreshold, threshold);
          this.countUpPromise = this.countUp(amountToCountUp, duration);
        } else {
          // already have a promise, this will be from the intro
        }
      }

      if (previousTitle && nextTitle) {
        if (!this.skipWin) {
          soundManager.play('bigwinUpgrade');
        }
        const scaleInTitlePromise = this.scaleInTitle(nextTitle, true);
        await scaleInTitlePromise;
      }

      if (nextTitle) {
        this.pulseTitle(nextTitle);
      }

      if (!this.skipWin) {
        this.allowSkipWin = true;
        this._skipBigWinBox.interactive = true;
      }

      // and then we need to wait for the count up to finish
      await this.countUpPromise;
      this.countUpPromise = null;
    }

    async showFinalResult() {
      soundManager.stop('winCountUp');
      this.countUpSound = null;
      soundManager.play('winCountUpEnd');
      this.pulseWinAwardText();
      await timerManager.delayAsync(1500);
      this.stopPulsingWinAwardText();
    }

    async fadeOut() {
      await Promise.all([
        this.tweenFromToAsync(
          this._bigWinContainer,
          {
            alpha: 1,
          },
          {
            alpha: 0,
            duration: 0.5,
          }
        ),
        this.tweenFromToAsync(
          this._dimScreen,
          {
            alpha: 0.6,
          },
          {
            alpha: 0,
            duration: 0.5,
          }
        ),
      ]);

      this._bigWinContainer.visible = false;
      this._bigWinContainer.alpha = 1;
    }

    stopAllEmitters() {
      this._emitter5.particleEmitter.emit = false;
      this._emitter5.visible = false;

      this._emitter4.particleEmitter.emit = false;
      this._emitter4.visible = false;

      this._emitter3.particleEmitter.emit = false;
      this._emitter3.visible = false;

      this._emitter2.particleEmitter.emit = false;
      this._emitter2.visible = false;

      this._emitter1.particleEmitter.emit = false;
      this._emitter1.visible = false;
    }

    async outro() {
      // start fading everything out
      const fadeOutPromise = this.fadeOut();
      const scaleOutAndFadeOffTitlePromise = this.scaleOutAndFadeOffTitle(this.currentTitle);
      const moveOutWinAwardTextBackingPromise = this.moveOutWinAwardTextBacking();
      await Promise.all([
        fadeOutPromise, //
        scaleOutAndFadeOffTitlePromise,
        moveOutWinAwardTextBackingPromise,
      ]);

      // now we cant be seen
      // clean up stuff
      this.stopAllEmitters();
      this.stopRotatingBursts();
      this.burst1.visible = false;
      this.burst2.visible = false;
      this._dimScreen.show(false);
    }

    skip() {
      if (this.canSkip()) {
        this._skipBigWinBox.interactive = false;
        this.allowSkipWin = false;
        this._winAwardText.cancelCountUp();
        this._winAwardText.set(this.winAmount);
        musicManager.stopBigWin();
        this.skipWin = true;
      }
    }
  }

  var bigWinCreator = function (json) {
    return new BigWin();
  };

  var bigWinInitialiser = function (json, bigWin) {};

  var bigWinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('BigWin', bigWinCreator, bigWinInitialiser, bigWinFilesRequired);
})();
